var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canDownload
    ? _c(
        "KButton",
        {
          ref: "button",
          attrs: { hasDropdown: "", primary: _vm.$attrs.primary },
          scopedSlots: _vm._u(
            [
              {
                key: "menu",
                fn: function () {
                  return [
                    _c("KDropdownMenu", {
                      attrs: { options: _vm.fileOptions, maxWidth: "none" },
                      on: { select: _vm.download },
                    }),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            2792022987
          ),
        },
        [_c("span", [_vm._v(_vm._s(_vm.$tr("downloadContent")))])]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }